{
  "abbreviations": {
    "house": "дом",
    "hull": "корпус",
    "appartement": "кв."
  },
  "account": {
    "addingAddress": "Добавление адреса",
    "address": "Адрес",
    "addressDeleted": "Адрес удалён",
    "addressEditing": "Редактирование адреса",
    "addresses": "Адреса",
    "addressInNativeAlphabet": "Адрес на кириллице",
    "balance": "Баланс",
    "customSenderTitle": "Данные отправителя",
    "customSenderDisabledTooltip": "Please fill out all required address fields",
    "customSenderDesc": "Отправить посылку от имени:",
    "demoMode": "Примеры посылок",
    "demoModeOn": "Показывать",
    "demoModeOff": "Не показывать",
    "hiUser": "Привет, {{ fullName }}!",
    "personInfo": "Паспортные данные получателя необходимы только для экспресс доставки .",
    "settings": "Настройки аккаунта",
    "settingsUpdated": "Настройки успешно обновлены",
    "theme": "Тема",
    "themeLight": "Светлая",
    "themeDark": "Тёмная",
    "themeSystem": "Системная",
    "userInfo": "Информация пользователя",
    "youWantDeleteAddress": "Вы уверены, что хотите удалить этот адрес?",
    "сustomID": "Паспортная информация",
    "details": "Details",
    "preferences": "Настройки",
    "preferencesHint": "Сохраняются в аккаунте и действуют на всех устройствах.",
    "unitsHint": "Для веса и размеров посылок.",
    "notificationsHint": "Как часто присылать письма об изменениях по посылкам.",
    "unsavedChanges": "Есть несохранённые изменения",
    "discard": "Отменить изменения",
    "appearance": "Внешний вид",
    "appearanceHint": "Применяется сразу и только на этом устройстве.",
    "demoModeDescription": "Показывать примеры посылок в пустых списках, чтобы увидеть, как работает сервис.",
    "security": "Безопасность",
    "securityHint": "Смена пароля для входа.",
    "showPasswords": "Показать пароли",
    "passwordUpdated": "Пароль изменён",
    "memberSince": "Дата регистрации",
    "suite": "Suite",
    "copySuite": "Скопировать номер Suite"
  },
  "invoiceParse": {
    "parsing": "Читаем чек…",
    "timeout": "Всё ещё читаем…",
    "keepWaiting": "Подождать ещё",
    "added": "Добавлено позиций из чека: {{count}}",
    "failed": "Не удалось прочитать чек",
    "unavailable": "Распознавание чеков сейчас недоступно.",
    "tryAgain": "Попробовать снова",
    "tooLarge": "Файл чека должен быть меньше 10 МБ"
  },
  "declarationFile": {
    "drop": "Перетащите файл сюда или",
    "choose": "Выбрать файл",
    "formatsSpreadsheet": "CSV, XLSX — декларация",
    "formatsReceipt": "JPG, PNG, WEBP, GIF, PDF до 10 МБ — чек",
    "unsupported": "Этот тип файла не поддерживается"
  },
  "addressParse": {
    "inputLabel": "Адрес получателя",
    "inputPlaceholder": "Иван Иванов, +7 918 123-45-67, ул. Рашпилевская 55, кв. 34, Краснодар, 350000, Россия",
    "inputHint": "Вставьте адрес текстом: имя, телефон, улица и дом, город, индекс и страна. Поля распознаются автоматически.",
    "requiredAny": "Вставьте текст адреса или приложите фото",
    "attachPhoto": "Приложить фото",
    "dropPhoto": "Перетащите фото сюда или",
    "photoFormats": "JPG, PNG, WEBP или GIF, до 10 МБ",
    "removePhoto": "Убрать фото",
    "photoWrongFormat": "Поддерживаются только изображения JPG, PNG, WEBP или GIF",
    "photoTooLarge": "Фото должно быть меньше 10 МБ",
    "recognize": "Распознать адрес",
    "enterManually": "Заполнить вручную",
    "parsing": "Распознаём адрес…",
    "parsingCanLeave": "Панель можно закрыть — если распознавание завершится успешно, адрес появится в вашем списке.",
    "parsingSlow": "Это занимает больше времени, чем обычно. Можно подождать ещё или заполнить адрес вручную.",
    "timeoutTitle": "Распознавание ещё не завершено",
    "keepWaiting": "Подождать ещё",
    "reviewHint": "Адрес добавлен в ваш список. Проверьте все поля перед использованием.",
    "useAddress": "Использовать этот адрес",
    "discard": "Удалить",
    "failedTitle": "Не удалось распознать адрес",
    "failedGeneric": "Попробуйте изменить текст или заполните адрес вручную.",
    "failedValidation": "Распознанный адрес не прошёл проверку:",
    "failedUnavailable": "Распознавание адресов временно недоступно. Пожалуйста, заполните адрес вручную.",
    "tryAgain": "Попробовать снова",
    "addedNotShown": "Адрес распознан и добавлен в ваш список."
  },
  "auth": {
    "alreadyHaveAnAccount": "Уже есть аккаунт? Войти",
    "changePassword": "Изменить пароль",
    "city": "Город",
    "country": "Страна",
    "dontHaveAccount": "Зарегистрироваться",
    "email": "Эл. адрес",
    "emailNotifications": "Уведомления по электронной почте",
    "originName": "Имя отправителя",
    "originAddress1": "Адресс отправителя",
    "originState": "Область отправителя",
    "originCity": "Город отправителя",
    "originZipCode": "Почтовый код отправителя",
    "firstName": "Имя",
    "flat": "Квартира",
    "forgotPassword": "Забыли пароль",
    "fullName": "ФИО",
    "house": "Номер дома",
    "hull": "Корпус",
    "iAgreeTo": "Я согласен с ",
    "lastName": "Фамилия",
    "locale": "Язык",
    "login": "Вход",
    "newPassword": "Новый пароль",
    "newPasswordConfirm": "Подтверждение нового пароля",
    "nextDeclaration": "Следующая декларация",
    "oldPassword": "Старый пароль",
    "passportFullName": "ФИО (пасспорт)",
    "passportIssued": "Пасспорт выдан",
    "passportIssuedDate": "Дата выдачи пасспорта",
    "passportNumber": "Номер пасспорта",
    "passportSerial": "Серия пасспорта",
    "password": "Пароль",
    "phone": "Телефон",
    "postalCode": "Почтовый индекс",
    "taxId": "ИНН",
    "rePassword": "Подтверждение пароля",
    "registration": "Регистрация",
    "resetPassword": "Сброс пароля",
    "signUp": "Регистрация",
    "stateOrRegion": {
      "US": "Штат",
      "other": "Область"
    },
    "startTypingAddress": "Поиск по адресам",
    "street": "Улица",
    "address1": "Адрес 1",
    "address2": "Адрес 2",
    "termsAndConditions": "правилами и условиями",
    "units": "Единицы измерения",
    "signupToken": "секретный токен",
    "yes": "Да",
    "no": "Нет",
    "handling": "Обработка посылок"
  },
  "common": {
    "addAddress": "Добавить {{ word }} адрес",
    "addCustomData": "Добавить таможенные данные",
    "addDeclaration": "Добавить декларацию",
    "addFilter": "Добавить фильтр",
    "addIdInformation": "Добавить паспортную информацию",
    "addToCart": "Добавить в корзину",
    "another": "другой",
    "areYouSureYouWantTo": "Вы уверены что хотите",
    "articleNotFound": "Статья не найдена",
    "backwards": "Назад",
    "back": "Назад",
    "cancel": "Отмена",
    "resume": "Продолжить",
    "cancelAndDelete": "Отменить и Удалить",
    "cancelConsolidation": "Отмена консолидации",
    "cancelRequest": "Отменить запрос",
    "change": "Изменить",
    "chooseParcels": "Перейти на Склад",
    "clear": "Очистить",
    "close": "Закрыть",
    "closeMenu": "Закрыть меню",
    "openMenu": "Открыть меню",
    "help": "Справка",
    "increase": "Увеличить",
    "decrease": "Уменьшить",
    "comment": "Комментарий",
    "partnerTransferId": "Partner SB ID",
    "continue": "Продолжить",
    "continueWithProcessing": "Продолжить обработку",
    "continueToPaypal": "Продолжить через Paypal",
    "continueToPaymentMethod": "Продолжить через {{ paymentMethod }}",
    "continueToBalance": "Оплатить с баланса",
    "noPaymentMethodsAvailable": "Нет доступных способов оплаты",
    "copiedSuccess": "Успешно скопировано",
    "creditCard": "Кредитная карта",
    "deleteAndLeave": "Удалить и Выйти",
    "deleteCartSuccess": "Запрос на упаковку удален",
    "deselect": "Отменить выбор",
    "doNotLeave": "Не уходить",
    "edit": "Редактировать",
    "editCustomsData": "Редактировать таможенные данные",
    "enter": "Введите",
    "field": "Поле",
    "free": "{{currencySymbol}}0.00",
    "from": "от",
    "fullSize": "Полноразмерное изображение",
    "goToOutgoing": "Перейти в Исходящие",
    "hide": "Скрыть",
    "learnMore": "Узнать больше",
    "loading": "Загрузка",
    "loadingWithLabel": "Загрузка {{ word }}",
    "moreOfficialInformation": "Больше официальной информации",
    "new": "новый",
    "nextStep": "Далее",
    "pageNotFound": "Упс. Похоже, эта страница не существует",
    "pay": "Оплатить",
    "payAll": "Оплатить всё",
    "prohibitedGoodsFound": "Запрещенные товары найдены",
    "remove": "Удалить",
    "reviewAndPay": "Просмотреть и оплатить",
    "reviewAndPrepay": "Оплатить до упаковки",
    "save": "Сохранить",
    "saveAndFinish": "Сохранить",
    "saveAndLeave": "Сохранить и Выйти",
    "saveChanges": "Сохранить изменения",
    "search": "Поиск",
    "selectAll": "Выбрать всё",
    "selectYear": "Выбрать год",
    "send": "Отправить",
    "sentIn": "Отправлено в",
    "sendTheCart": "Отправить корзину",
    "show": "Показать",
    "show5More": "Показать еще 5",
    "state": "Состояние",
    "takeMeBack": "Вернуться на домашнюю страницу",
    "to": "до",
    "undo": "Отменить",
    "yes": "Да",
    "no": "Нет",
    "copiedToClipboard": "Скопировано",
    "csvShipments": "Посылки в CSV",
    "processBankCard": "Процесс банковскую карту",
    "processPaypal": "Процесс Paypal",
    "processStripe": "Продолжить через Stripe",
    "processOverpay": "Оплатить через Overpay",
    "stripe": "Stripe",
    "stripePay": "Оплатить {{amount}} через Stripe",
    "stripeEditAmount": "Изменить сумму",
    "stripeLoading": "Загрузка защищённой формы оплаты Stripe",
    "stripeProcessing": "Платёж Stripe всё ещё обрабатывается. Мы завершим его автоматически, когда он будет готов.",
    "stripeInvalidReturn": "Не удалось подтвердить возвращённый платёж Stripe.",
    "stripePaymentFailed": "Stripe не удалось завершить платёж. Попробуйте ещё раз.",
    "stripePaymentSucceeded": "Платёж Stripe успешно завершён.",
    "overpay": "Overpay СБП",
    "options": "Параметры",
    "assignComment": "Назначить комментарий"
  },
  "dashboard": {
    "coupons": "Купоны",
    "couponsAdded": "добавленно",
    "new": "Новых посылок",
    "newCoupons": "{{ number }} новых купонов ",
    "newDelivery": "Строки мудрости от",
    "newUpdate": "Новое обновление на сайте",
    "online": "онлайн",
    "qa": "Информация",
    "sent": "Отправлено",
    "waiting": "Ожидающие действия",
    "warehouseAddress": "Адрес склада",
    "warehouseClose": "ЗАКРЫТ",
    "warehouseClosing": "Закрытие в",
    "warehouseIs": "Склад",
    "warehouseOpen": "ОТКРЫТ",
    "warehouseOpening": "Открытие в",
    "yourAddress": "Ваш адрес в США",
    "filterKnowledgeBase": "Find information in knowledge base",
    "noResultsFound": "Ничего не найдено"
  },
  "paymentInfoConfirmation": {
    "confirmationTitle": "Confirm declared value!",
    "willBeSent": "Отправление для",
    "addressPrefix": "на",
    "shipmentTotal": "Таможенная стоимость составляет",
    "confirmationHint": "Пожалуйста, подтвердите, что данные верны. Изменения после оплаты невозможны.",
    "cancel": "Пересмотреть данные",
    "confirm": "Подтвердить"
  },
  "dev": {
    "buttons": "Кнопки",
    "checkboxes": "Чекбоксы",
    "datepicker": "Выбор даты",
    "icons": "Иконки",
    "images": "Картинки",
    "inputs": "Ввод данных",
    "openRightPanel": "Открыть правую панель",
    "pageInDev": "Страница в разработке",
    "pages": "Страницы",
    "rightPanel": "Правая панель",
    "selects": "Селекты",
    "toasts": "Всплывающие сообщения",
    "tooltips": "Всплывающие подсказки"
  },
  "emailNotifications": {
    "eachEvent": "После каждого события",
    "oncePerDay": "Один раз в день",
    "oncePerWeek": "Один раз в неделю"
  },
  "error": {
    "atLeastOne": "Должно быть выбрано хотя бы одно поле.",
    "dateLessThanCurrent": "Дата должна быть меньше текущей",
    "englishOnly": "Пожалуйста, используйте английский",
    "englishAndCyrillicOnly": "Пожалуйста, используйте английский или русский",
    "validHouseNumber": "Разрешаются только буквы, цифры и знак /",
    "hasLowercase": "Строка должна содержать как минимум 1 строчный алфавитный символ",
    "hasNumeric": "Строка должна содержать как минимум 1 числовой символ",
    "hasUppercase": "Строка должна содержать как минимум 1 заглавный алфавитный символ",
    "hasSymbol": "Пароль должен содержать хотя бы 1 спецсимвол",
    "hasAlphabetical": "Строка должна содержать как минимум 1 алфавитный символ",
    "invalid": "{{ field }} — неверное значение",
    "invalidRePass": "Пароли не совпадают",
    "numberLonger": "{{ field }} должен иметь {{ length }} цифр",
    "numberWithSingleLetter": "Строка может содержать одну букву после числа, например: \"23\" или \"2B\"",
    "onlyNumber": "Только цифры",
    "passMatch": "Пароли не совпадают",
    "phoneNumberIsNotFully": "Номер телефона введён не полностью",
    "required": "{{ field }} — обязательное поле",
    "requiredField": "Это поле обязательное",
    "someFieldsHasErrors": "Некоторые поля содержат ошибки",
    "stringLonger": "Строка должна содержать не менее {{ length }} символов",
    "stringShorter": "Строка должна содержать не более {{ length }} символов",
    "whiteSpaces": "Строка не должна содержать пробелы",
    "withAlphabetic": "Строка должна содержать хотя бы один буквенный символ",
    "paymentWasCanceled": "The payment was canceled",
    "creditCard": {
      "wrongExpirationFormat": "Срок действия должен соответсвовать формату: MM/YYYY"
    },
    "duplicateRowCustomData": "В данных есть дублирующиеся строки. Пожалуйста, проверьте выделенные поля и убедитесь, что каждая запись уникальна.",
    "requestTimeout": "Сервер слишком долго не отвечает. Пожалуйста, попробуйте ещё раз."
  },
  "errorPasswordSignup": {
    "length": "Минимум {{ length }} символов",
    "numeric": "Минимум 1 цифровой символ",
    "alphabetical": "Минимум 1 буквенный символ",
    "symbol": "Минимум 1 символ",
    "whiteSpaces": "Нет пробелов"
  },
  "appError": {
    "title": "Что-то пошло не так",
    "description": "Произошла непредвиденная ошибка, и страницу нужно перезагрузить.",
    "reload": "Перезагрузить страницу"
  },
  "imageViewer": {
    "fullscreen": "Во весь экран",
    "next": "Следующее изображение",
    "prev": "Предыдущее изображение"
  },
  "inbound": {
    "addShipment": "Добавить отправление",
    "shipFromAddresses": "Адреса отправителя",
    "importCsv": "Импорт из CSV",
    "tabs": {
      "shipments": "Отправления"
    },
    "emptyList": "У вас пока нет входящих отправлений",
    "shipmentTitle": "Отправление на склад",
    "newShipmentTitle": "Новое отправление на склад",
    "placeholderIcon": "Иконка-заглушка — нет входящих отправлений",
    "addAddress": "Добавить новый адрес",
    "deleteConfirmTitle": "Удалить отправление",
    "deleteConfirmText": "Отправление будет удалено безвозвратно. Продолжить?",
    "form": {
      "address": "Откуда",
      "weight": "Вес",
      "height": "Высота",
      "length": "Длина",
      "width": "Ширина",
      "comment": "Комментарий",
      "packageTitle": "Посылка {{number}}",
      "addPackage": "Добавить посылку",
      "removePackage": "Удалить посылку"
    },
    "list": {
      "packages": "Посылок: {{amount}}"
    },
    "status": {
      "draft": "Черновик",
      "estimated": "Тариф получен",
      "labeled": "Этикетка создана"
    },
    "quote": {
      "title": "Тарифы доставки",
      "getQuote": "Получить тарифы",
      "buyLabel": "Купить этикетку",
      "shipping": "Стоимость доставки",
      "deliveryDays": "Доставка: {{amount}} дн.",
      "volumetricExtra": "Надбавка за объёмный вес",
      "volumetricWarning": "Перевозчик рассчитает стоимость по объёмному весу посылки.",
      "staleOnEdit": "Сохранение изменений сбросит текущий тариф.",
      "expiredNote": "Тарифы со временем устаревают. Получите тарифы заново, чтобы купить этикетку.",
      "noRates": "Для этого отправления нет доступных тарифов."
    },
    "label": {
      "title": "Транспортная этикетка",
      "trackingNumber": "Трек-номер",
      "download": "Скачать этикетку",
      "cost": "Стоимость этикетки",
      "insurance": "Страховка",
      "totalCharged": "Итого списано",
      "packagesTitle": "Этикетки посылок",
      "cancel": "Отменить этикетку",
      "cancelConfirmTitle": "Отменить этикетку",
      "cancelConfirmText": "Купленная этикетка будет аннулирована, использовать её больше нельзя. Продолжить?"
    },
    "parse": {
      "open": "Вставить посылки",
      "title": "Посылки из текста",
      "description": "Опишите каждую посылку отдельным абзацем: ваш внутренний номер, вес и габариты, адрес получателя и вложения с количеством и ценой. Отправление создаётся для выбранного адреса отправителя.",
      "placeholder": "Заказ A-100: 2 кг, 30x20x10 см.\nАнна Сидорова, Казань, Садова 10, кв 5, +7 900 123 45 67.\nКроссовки 1 шт $120, носки 2 шт $10.",
      "submit": "Создать отправление",
      "parsing": "Распознаём посылки…",
      "parsingHint": "Обычно это занимает меньше минуты.",
      "timeout": "Всё ещё работаем…",
      "keepWaiting": "Подождать ещё",
      "success": "Отправление создано",
      "failedTitle": "Не удалось создать отправление",
      "failedValidation": "Исправьте и попробуйте снова:",
      "unavailable": "Распознавание сейчас недоступно. Используйте импорт из CSV или добавьте отправление вручную.",
      "tryAgain": "Попробовать снова"
    },
    "import": {
      "title": "Импорт отправления из CSV",
      "description": "Один CSV-файл создаёт одно отправление на склад; каждая строка — одна посылка. Обязательные колонки: weight, height, length, width. Необязательная: customer_comment.",
      "selectFile": "Выбрать CSV-файл",
      "submit": "Импортировать",
      "downloadExample": "Скачать пример CSV",
      "success": "Отправление импортировано",
      "wrongFormat": "Файл должен быть в формате CSV",
      "tooLarge": "Файл слишком большой (макс. 5 МБ)",
      "moreErrors": "…и ещё ошибок: {{amount}}"
    },
    "addresses": {
      "addAddress": "Добавить адрес",
      "search": "Поиск по имени и адресу",
      "notFound": "Адреса не найдены",
      "empty": "У вас пока нет адресов отправителя",
      "addingTitle": "Новый адрес отправителя",
      "editingTitle": "Изменить адрес отправителя",
      "name": "Полное имя",
      "phone": "Телефон",
      "addressLine1": "Адрес, строка 1",
      "addressLine2": "Адрес, строка 2",
      "city": "Город",
      "state": "Штат",
      "zipCode": "Почтовый индекс (ZIP)"
    }
  },
  "locales": {
    "en": "Английский",
    "ru": "Русский"
  },
  "localesNative": {
    "en": "English",
    "ru": "Русский"
  },
  "notifications": {
    "eachEvent": "После каждого события",
    "oncePerDay": "Один раз в день",
    "oncePerWeek": "Один раз в неделю"
  },
  "mailbox": {
    "copyAddress": "Скопировать адрес",
    "copyField": "Скопировать: {{field}}",
    "fields": {
      "name": "Имя",
      "addressLine1": "Адрес, строка 1",
      "addressLine2": "Адрес, строка 2",
      "city": "Город",
      "zip": "Индекс (ZIP)",
      "phone": "Телефон"
    },
    "suite": "Suite {{suite}}",
    "suiteNote": "{{suite}} — ваш личный номер. Указывайте его в поле Address line 2, иначе посылку не получится привязать к вашему аккаунту."
  },
  "pages": {
    "404": "404",
    "terms": "Условия использования",
    "privacy": "Политика конфиденциальности",
    "refund-policy": "Возвраты и отмены",
    "prohibited-items": "Запрещённые товары",
    "account": "Aкаунт",
    "settings": "Настройки",
    "clients": "Пользователи",
    "containers": "Контейнеры",
    "history": "Отправлено",
    "logout": "Выход",
    "orders": "Заказы",
    "outgoing": "К отправке",
    "parcels": "Посылки",
    "password-change": "Изменить пароль",
    "password-reset": "Забыли пароль",
    "shipping": "Оформление посылки",
    "signin": "Вход",
    "signout": "Выйти",
    "signup": "Регистрация",
    "storage": "Склад",
    "expected": "В пути на склад",
    "inbound": "Отправка на склад",
    "transactions": "Транзакции",
    "books": "Финансы",
    "tools": "Инструменты",
    "shopify": "Shopify",
    "mailbox": "Почтовые ящики",
    "support": "Поддержка",
    "home": "Главная",
    "recipients": "Получатели",
    "utilities": "Утилиты"
  },
  "containers": {
    "emptyList": "У вас пока нет контейнеров",
    "emptyShipments": "В этом контейнере пока нет посылок",
    "weight": "Вес",
    "dimensions": "Размеры",
    "created": "Создан",
    "state": {
      "open": "Открыт",
      "closed": "Закрыт"
    }
  },
  "parcels": {
    "additionalInfoMessage": "Пожалуйста, укажите дополнительную информацию, которую мы должны знать",
    "additionalOptions": "Дополнительные параметры",
    "approximateDeliveryCost": "Ориентировочная стоимость доставки",
    "cancel": "Отменить",
    "cancelConsolidationSuccess": "Отмена консолидации прошла успешно",
    "cancelPacking": "Отменить упаковку",
    "cancelPackingMessage": "Все ваши посылки будут возвращены в раздел склад",
    "commentsInProcess": "Получение комментариев в процессе",
    "confirmCancelPacking": "Да, отменить упаковку",
    "continuePacking": "Нет, продолжить с упаковкой",
    "costPerKg": "Стоимость за кг",
    "createdAt": "Создан",
    "creditCardNotAvailable": "Оплата кредитной картой в данный момент недоступна",
    "customsData": "Таможенные данные",
    "customsDeclarations": "Таможенные декларации",
    "changingAddress": "Изменение адреса",
    "dateReceived": "Дата получения",
    "daysLeft": "{{ days }} дней осталось",
    "currentParcelGuide": {
      "backToList": "Вернуться к списку",
      "openDetails": "Открыть детали посылки",
      "steps": {
        "address": "Выберите адрес доставки",
        "checkout": "Нажмите «Продолжить» внизу, чтобы проверить и оплатить",
        "customs": "Заполните таможенную декларацию",
        "method": "Выберите способ доставки",
        "packing": "Выберите упаковку",
        "review": "Проверьте вложения посылки"
      },
      "subtitle": "Ваши грузы со склада уже в этой посылке. Выполните шаги, чтобы отправить её.",
      "title": "Посылка {{sku}} собирается",
      "toggle": "Как завершить посылку?"
    },
    "demo": {
      "actionHint": "Это пример посылки — действия недоступны. Они заработают, когда на склад поступит ваша настоящая посылка.",
      "badge": "Пример",
      "cta": {
        "addressLabel": "Ваш адрес ({{country}})",
        "declareExpected": "Заявить ожидаемую посылку",
        "subtitle": "Оформляйте заказы на адрес нашего склада. Мы примем посылку, взвесим и сфотографируем её — и она появится в этом списке, обычно в течение 24 часов после доставки на склад.",
        "whatToShip": "Что можно отправлять"
      },
      "expectedSubtitle": "Это примеры. Заявленные посылки появятся здесь до поступления на склад — нажмите на строку, чтобы открыть форму посылки.",
      "expectedTitle": "Примеры ожидаемых посылок — так будет выглядеть ваш список",
      "hide": "Скрыть примеры",
      "hideConfirmation": "Примеры посылок скрыты. Включить их снова можно в настройках аккаунта.",
      "itemsSubtitle": "Это примеры. Товары, зарегистрированные на складе, появятся здесь — нажмите на строку, чтобы посмотреть карточку товара.",
      "itemsTitle": "Примеры товаров — так будет выглядеть содержимое посылок",
      "outgoingSubtitle": "Это примеры. Посылки в упаковке и готовые к оплате появятся здесь — нажмите на строку, чтобы посмотреть карточку отправления.",
      "outgoingTitle": "Примеры исходящих посылок — так будет выглядеть ваш список",
      "subtitle": "Это примеры. Когда посылка поступит на склад, она появится здесь — нажмите на строку, чтобы посмотреть карточку посылки.",
      "title": "Примеры посылок — так будет выглядеть ваш список"
    },
    "delivery": "Доставка",
    "description": "Описание",
    "details": "Подробности",
    "empty": "У вас пока нет пакетов для отправки",
    "emptyHistory": "Раздел для информации о консолидациях ваших заказов отправленных с нашего склада",
    "searchByTrackingNumber": "Поиск по трек-номеру",
    "searchBySku": "Поиск по SKU консолидации",
    "historyForSelectedYear": "История за {{ selectedYear }} год",
    "inProgress": "В работе",
    "insurance": "Страхование",
    "insuranceMessage": "Мы предоставляем нашим клиентам стандартную страховку (12,5% от общей стоимости товара) для наиболее распространенных случаев страхования.",
    "itemDeleted": "Элемент удалён",
    "item": "заказ",
    "items": "заказа",
    "leaveComment": "Добавить комментарий",
    "makePaymentWithin": "Произвести оплату в течение",
    "notFinished": "Не закончен",
    "notSelectedYet": "Ещё не выбран",
    "numberNotFound": "номер не найден",
    "packOptionsSaved": "Параметры упаковки сохранены для {{ number }}",
    "package": "Упаковка",
    "excessPackagesIncluded": "Лишние посылки",
    "packagesIncluded": "Посылки",
    "shipments": "Посылки",
    "showAll": "Показать все {{count}}",
    "showMore": "Показать ещё {{count}}",
    "shownOf": "{{shown}} из {{total}}",
    "packing": "Упаковка",
    "packingGrade": "Kласс упаковки",
    "packingGradeAndOptions": "Упаковка",
    "packingServiceRequests": "Сервисные услуги",
    "packingOptions": "Опции упаковки",
    "packingInGenitive": "упаковку",
    "paid": "Отправляется",
    "paidUsing": "Оплачено с помощью",
    "parcelInformation": "Информация о посылке",
    "parcelsInformation": "Информация о посылках",
    "parcelWeight": "Вес посылки",
    "parcels": "посылок",
    "parcel": "посылка",
    "placeholderIcon": "Значек заполнителя - 0 посылок",
    "paymentMethod": "Способ оплаты",
    "price": "Цена",
    "priceInfo": "Информация о цене",
    "prohobitedGoods": "Запрещенные товары",
    "prohobitedGoodsWarning": "В вашей посылке были обнаружены запрещенные товары. Вы можете посмотреть фотографии их ниже. Пожалуйста, выберите, что делать с ними.",
    "putYourComment": "Оставить комментарий",
    "quantity": "Кол-во",
    "receivedDate": "Получено",
    "requestCanceled": "Запрос был отменен",
    "returnToStore": "Вернуть в магазин",
    "search": {
      "applyFilter": "Применить",
      "date": "Дата",
      "dateEnd": "Дата до",
      "dateFrom": "Начиная с",
      "dateRangeError": "Введите корректную дату, дата окончания не может быть больше даты начала или текущей даты",
      "dateStart": "Дата начала",
      "dateTill": "До",
      "dismiss": "Отменить",
      "exactDates": "Точные даты",
      "filterByTransactionNumber": "Поиск по складу и истории",
      "filterByTrackingNumber": "Поиск по складу",
      "found": "Посылок найдено",
      "inventoryItemsFound": "В инвентаре найдены предметы",
      "items": "Предметы",
      "lastMonth": "Прошлый месяц",
      "lastWeek": "Прошлая неделя",
      "resetFilter": "Сбросить фильтр",
      "selectDate": "Выберите дату получения посылки:",
      "selectShop": "Выберите магазин:",
      "selectComment": "Введите комментарий:",
      "selectOrder": "Введите заказы:",
      "searchMode": "Режим поиска",
      "shipments": "Посылки",
      "shop": "Магазин",
      "specifyWeight": "Укажите вес посылки:",
      "today": "Cегодня",
      "tools": "Инструменты",
      "tryAnotherSearch": "Попробуйте другой поиск",
      "weight": "Вес",
      "yesterday": "Вчера",
      "comment": "Комментарий",
      "order": "Заказы"
    },
    "itemsView": {
      "viewMode": "Режим просмотра",
      "rowsView": "Список",
      "tilesView": "Плитка",
      "tileColumns": "Плиток в ряду",
      "nextPhoto": "Следующее фото"
    },
    "selectedAmount": "Количество выбраных",
    "shipmentNotSend": "В данный момент эта посылка недоступна к отправке",
    "shipmentProhibited": "Запрещено к отправке. Обратитесь в службу поддержки.",
    "shippingAddress": "Адрес доставки",
    "shippingMethod": "Способ доставки",
    "startSelectingForSending": "Раздел для информации о консолидациях ваших заказов в процессе упаковки и оплаты доставки",
    "total": "{{ amount }} Всего",
    "totalLabel": "Всего",
    "totalPackingCost": "Общая стоимость упаковки",
    "totalPrice": "Общая цена:",
    "totalWeight": "Общий вес:",
    "vendor": "Поставщик",
    "waitingForInformation": "Ожидается больше информации",
    "waitingForPayment": "Готово к оплате",
    "paymentPaid": "Оплачено",
    "wantToSend": "Хочу отправить",
    "warehouseComment": "Ответ со склада",
    "week": "Неделя {{ numberWeek }}",
    "weight": "Вес",
    "whatToCheck": "Пожалуйста, укажите особенности проверки",
    "whenPackageSentExtra": "При отправке посылки дополнительные средства будут возвращены на ваш счёт для последующего использования",
    "youDontAnyOutgoingParcels": "Ожидаем консолидацию",
    "youNotFinishedProcessing": "У вас есть незавершеннаый запрос на упаковку, вы необходимо закончить или отменить его, прежде чем начинать новый.",
    "balance": "Текущий баланс",
    "negativeBalanceTooltip": "У вас отрицательный баланс. Счёт будет увеличен на эту сумму.",
    "positiveBalanceTooltip": "У вас положительный баланс. Счёт будет уменьшен на эту сумму.",
    "commissionFeeLabel": "Комиссия за обработку платежа ({{fee}}%)",
    "totalToPay": "Всего к оплате",
    "paymentByBalance": "Возможна оплата за счет текущего баланса",
    "state": {
      "paid": "Отправляется",
      "pending": "Ожидание упаковки",
      "claimed_for_packing": "В процессе упаковки",
      "picked": "В процессе упаковки",
      "claimed": "В процессе упаковки",
      "waiting_for_task": "Ожидание упаковки"
    },
    "paidDate": "Оплачен",
    "createdDate": "Создан",
    "brutto": "брутто",
    "shipped": "Отправлено",
    "moreDetails": "Подробнее",
    "notFinishedShowRequiredFieldsError": "Пожалуйста, заполните все обязательные поля"
  },
  "serviceRequests": {
    "title": "Сервисы",
    "submit": "Запросить",
    "additionalPhotos": {
      "message": "Запрос на фото проверку выполняется в течение 24 часов",
      "paragraph": "Несколько фото товаров внутри",
      "processed": "Ваши фото готовы",
      "submit": "Запросить фото",
      "title": "Фото",
      "unprocessed": "Выполняется"
    },
    "check": "Просмотреть",
    "done": "Готово",
    "packOptions": {
      "costHeading": "Стоимость опций",
      "heading": "Индивидуальные опции имеют приоритет над опциям для посылки в целом",
      "paragraph": "Вы можете заранее выбрать опции упаковки для этой посылки. Они будут автоматически применены в процессе создания запроса на упаковку.",
      "submit": "Сохранить",
      "title": "Опции упаковки",
      "tooltip": "Подсказка"
    },
    "inventory": {
      "title": "Содержимое посылки"
    },
    "removeFromConsolidation": {
      "actionText": "Удалить из консолидации"
    },
    "placeholderComment": "Комментарий к запросу",
    "powerCheck": {
      "message": "Обычно это занимает около 2 дней. Когда питание проверено, вы увидите индикатор в строке",
      "paragraph": "Для вас мы могли бы проверить, работают ли электрические устройства, и снять короткое видео о проверке мощности.",
      "processed": "Проверка посылки выполнена",
      "submit": "Проверить мощность",
      "title": "Проверка мощности",
      "unprocessed": "Проверка мощности в процессе..."
    },
    "processTime": "Обычно это занимает около 2 дней",
    "requestCost": "Стоимость сервиса",
    "returnPackage": {
      "title": "Вернуть в магазин",
      "writeUsFirstPart": "Вы можете написать нам на почту: ",
      "writeUsSecondPart": "чтобы вернуть посылку в магазин"
    },
    "serviceByInstruction": {
      "message": "Cервис выполняется в течение 24-48 часов",
      "paragraph": " Проверка товаров по вашей инструкции. Примеры: включение гаджетов, проверка на наличие брака, точные замеры одежды/обуви,",
      "processed": "Выполнено",
      "submit": "Запросить",
      "title": "Подробная проверка",
      "unprocessed": "Выполняется"
    },
    "requestInventoryShipment": {
      "title": "Регистрация содержимого посылки",
      "submit": "Запросить",
      "paragraph": "Регистрация всех товаров в посылке, индивидуально",
      "paragraph2": "Каждая вещь маркируется уникальным штрих-кодом, фотографируется и взвешивается.",
      "cost": "2.00",
      "costSuffix": " + {{currencySymbol}}0.2/вещь"
    },
    "requestTransferShipment": {
      "title": "Перенос",
      "submit": "Запросить",
      "paragraph": "Предоставьте номер аккаунта для переноса посылки. Обратите внимание на код трансфера который понадобится для активации посылки в новом аккаунте.",
      "paragraphClientTransferring": "Пожалуйста, укажите код перевода, чтобы принять это отправление.",
      "processed": "Запрошено",
      "transferPartnerId": "Номер аккаунта",
      "transferPartnerCode": "Код трансфера",
      "transferCompleteCode": "Принять посылку по коду"
    },
    "states": {
      "canceled": "Отменено",
      "declined": "Отказано",
      "pending_moderation": "Выполняется",
      "pending_translation": "Выполняется",
      "processed": "Выполнено",
      "requested": "Выполнено",
      "translated": "Выполняется",
      "unprocessed": "Выполняется",
      "warehouse_requested": "Выполняется"
    }
  },
  "shipping": {
    "additionalСost": "Общая стоимость опций упаковки",
    "address": "Адрес",
    "allPackages": "Посылка в целом",
    "amountOfItemsInCart": "Количество",
    "cancelSending": "Отменить отправку",
    "cancellation": "Отмена",
    "cartDetails": "Информация о корзине",
    "checkCustomData": "Таможенная декларация",
    "customData": "Таможеннная декларация",
    "delivery": "Cпособ доставки",
    "deliveryAndPacking": "Доставка и упаковка",
    "deliveryCost": "Ориентировочная стоимость доставки",
    "done": "Завершить",
    "payAfterPacking": "Оплатить после упаковки",
    "includingInsurance": "Добавить страховку",
    "insurance": "Cтраховка",
    "leave": "Выйти и отменить",
    "leaveProcessing": "Покинуть запрос на упаковку",
    "optionsForAllPackages": "Общие опции",
    "optionsForIndividualItems": "Индивидуальные опции и услуги",
    "packing": "Класс упаковки",
    "packingСost": "Стоимость упаковки",
    "expectedСost": "Ожидаемая стоимость",
    "totalExpectedСost": "Общая ожидаемая стоимость",
    "services": "Услуги",
    "payInAdvance": "Оплатить по брутто весу",
    "payInAdvanceHelpMessage": "При наличии разницы в цене, она будет зачислена на ваш баланс и добавлена в счет на следующую посылку.",
    "payInAdvanceMessage": "Хотите, чтобы посылку отправили сразу после завершения упаковки?",
    "price": "Цена",
    "remain": "Остаться",
    "selectAdditional": "Основные варианты для",
    "selectAdditionalShipment": "Варианты для",
    "selectAddress": "Выберите адрес доставки",
    "selectDelivery": "Выберите способ доставки",
    "selectPacking": "Выберите класс упаковки",
    "steps": {
      "1": "Шаг 1 - Адрес",
      "2": "Шаг 2 - Доставка",
      "3": "Шаг 3 - Упаковка",
      "4": "Шаг 4 - Дополнительные параметры",
      "5": "Шаг 5 - Таможенная декларация",
      "6": "Финальный шаг - Сводка"
    },
    "summary": " Сводка",
    "total": "Всего",
    "totalCostDescription": "Стоимость упаковки не включает стоимость доставки. Примерную стоимость доставки вы можете узнать в поле «Оплатить заранее»",
    "totalСost": "Доставка по брутто весу",
    "youAreLeaving": "Вы уходите",
    "addonsCost": "Стоимость дополнений",
    "serviceAndOptions": "Сервисы и опции",
    "addUrlLinks": "Добавить URL-ссылки",
    "totalRows": "строк",
    "singularCustomsSummary": "строка",
    "pluralCustomsSummary": "строк",
    "quantityCustomsSummary": "Кол-во",
    "customsSummaryValue": "стоимость",
    "noHsCodeFound": "Описание не найдено",
    "noAddressFound": "Адрес не найден"
  },
  "units": {
    "kg": {
      "title": "кг / см",
      "primaryShort": "кг",
      "secondaryShort": "см"
    },
    "lbs": {
      "title": "фунт / дюйм",
      "primaryShort": "ф.",
      "secondaryShort": "дюйм"
    }
  },
  "handling": {
    "processWhole": {
      "title": "Посылка целиком",
      "description": "Посылка регистрируется целиком и остаётся упакованной."
    },
    "processIndividual": {
      "title": "По отдельным товарам",
      "description": "Посылку вскрывают и регистрируют каждый товар отдельно, чтобы отправлять часть товаров или объединять товары из разных посылок."
    }
  },
  "popup": {
    "notFinished": {
      "deletionConfirmation": "Вы уверены, что хотите удалить эту посылку?"
    }
  },
  "conjugation": {
    "packages": {
      "1": "Одна коробка",
      "2": "Две коробки",
      "3": "Три коробки",
      "4": "Четыре коробки",
      "5": "Пять коробок",
      "6": "Шесть коробок",
      "7": "Семь коробок",
      "8": "Восемь коробок",
      "9": "Девять коробок",
      "10": "Десять коробок",
      "nth": "{{ count }} коробок"
    }
  },
  "purchase": {
    "creditCard": {
      "billingAddress": "Платежный адрес",
      "articles": {
        "refundPolicy": "Политика возврата",
        "privacyPolicy": "Политика конфиденциальности",
        "termsOfService": "Условия использования",
        "cancellations": "Отмены",
        "contact": "Контакты"
      },
      "countryRegion": "Страна/регион",
      "name": "Имя на карте",
      "number": "Номер карты",
      "expiration": "Срок действия (MM/YYYY)",
      "cvv": "Код безопасности",
      "address": "Адрес",
      "address2": "Квартира, офис и т.д. (необязательно)",
      "state": "Штат",
      "zipCode": "ZIP код",
      "cvvTooltip": "3-значный код безопасности обычно находится на обратной стороне карты. У карт American Express 4-значный код расположен на лицевой стороне.",
      "secureNotice": "Все транзакции защищены и зашифрованы."
    }
  },
  "tooltips": {
    "shipmentIsBox": "Эта посылка - коробка",
    "shipmentIsBag": "Эта посылка - пакет",
    "excessMarker": "Некоторые товары возвращены на склад"
  },
  "tools": {
    "putAway": "Размещение",
    "putAwaySuccess": "Посылка успешно перемещена",
    "printUsers": "Пользователи печати",
    "createPrintUser": "Создать пользователя",
    "editPrintUser": "Редактировать пользователя",
    "viewPrintUser": "Пользователь печати",
    "deleteConfirmation": "Вы уверены, что хотите удалить этого пользователя?",
    "changePassword": "Изменить пароль",
    "email": "Email",
    "uid": "UID",
    "password": "Пароль",
    "passwordConfirmation": "Подтверждение пароля",
    "createdAt": "Дата создания",
    "deletePrintUser": "Удалить",
    "noPrintUsers": "Нет пользователей печати"
  },
  "books": {
    "transactions": "Транзакции",
    "recipients": "Адреса",
    "addFunds": "Добавить средства",
    "searchRecipients": "Поиск по имени и адресу",
    "notFoundRecipients": "Получатель не был найден",
    "importAddresses": "Импорт из CSV",
    "importAddressesSuccess": "Импортировано адресов: {{amount}}",
    "importAddressesWrongFormat": "Файл должен быть в формате CSV",
    "importAddressesTooLarge": "Файл слишком большой (макс. 5 МБ)",
    "importAddressesDrop": "Перетащите CSV-файл сюда или",
    "importAddressesChooseFile": "Выбрать файл",
    "importAddressesFormats": "CSV, до 5 МБ",
    "importAddressesDownloadExample": "Скачать пример CSV",
    "importAddressesMoreErrors": "…и ещё ошибок: {{amount}}",
    "passports": {
      "title": "Паспорта",
      "searchPassports": "Поиск по имени",
      "addPassport": "Добавить паспорт",
      "viewPassport": "Данные паспорта",
      "create": "Создать паспорт",
      "fullName": "ФИО",
      "serial": "Серия",
      "number": "Номер",
      "issuedBy": "Кем выдан",
      "registration": "Адрес регистрации",
      "taxId": "ИНН",
      "issuedDate": "Дата выдачи",
      "dateOfBirth": "Дата рождения",
      "notFound": "Паспорта не найдены"
    },
    "addFundsBtnTitle": "Пополнение средств через банковскую карту",
    "addFundsPanel": {
      "chargeBankCard": "Зачисление на банковскую карту",
      "successfulTransactions": "Успешная сделка для ${{ amount }}",
      "chargePaypal": "Пополнение средств через Paypal",
      "chargeStripe": "Пополнение средств через Stripe",
      "chargeOverpay": "Пополнение средств через Overpay СБП",
      "addAmountToBalance": "Сумма пополнения баланса",
      "paymentProcessingFee": "Комиссия за обработку платежа {{feePercent}}%"
    },
    "voucherFundsPanel": {
      "panelTitle": "Balance vouchers",
      "titleCreate": "Create",
      "titleRedeem": "Redeem",
      "titleLog": "Log"
    },
    "usdt": {
      "panelTitle": "Пополнить баланс через USDT",
      "recentDeposits": "Последние депозиты",
      "noDeposits": "Депозитов пока нет",
      "successfulTransactions": "Депозит {{amount}} USDT получен. Баланс обновлён."
    },
    "errorAmountRangeAddFunds": "Сумма должна быть в диапазоне от {{currencySymbol}}{{min}} до {{currencySymbol}}{{max}}.",
    "search": {
      "filterByDescription": "Поиск по oписание",
      "filterByAmount": "Сумма",
      "tryAnotherSearch": "Попробуйте другой поиск",
      "found": "Транзакции найдено"
    },
    "bankCard": {
      "title": "Банковскую Карту",
      "successfulTransactions": "Успешная сделка для {{currencySymbol}}{{ amount }}"
    },
    "paypal": {
      "successfulTransactions": "Успешная сделка для {{currencySymbol}}{{ amount }}"
    },
    "stripe": {
      "title": "Stripe",
      "successfulTransactions": "Успешная сделка для {{currencySymbol}}{{ amount }}"
    },
    "overpay": {
      "title": "Overpay СБП",
      "successfulTransactions": "Успешная сделка для ${{ amount }}"
    },
    "voucher": {
      "title": "Балансовый ваучер",
      "successfulTransactions": "Успешная сделка для {{currencySymbol}}{{ amount }}",
      "successfulRedeemTransactions": "Успешная redeem for code ${{ code }}",
      "createVoucher": "Create voucher"
    }
  },
  "usdtDeposit": {
    "addToBalance": "Пополнение баланса",
    "fee": "Комиссия за обработку",
    "feePercent": "Комиссия за обработку ({{percent}}%)",
    "feeCombined": "Комиссия за обработку ({{percent}}% + {{fixed}} USDT)",
    "sendAtLeast": "Отправьте не менее",
    "minAmount": "Минимальный депозит",
    "checkPayment": "Я оплатил — проверить платёж",
    "checkingUntil": "Проверяем поступление перевода до {{time}}.",
    "checkAgainAt": "Проверить снова можно в {{time}}.",
    "received": "Для этой оплаты уже зачислено {{amount}}.",
    "completing": "Платёж получен, завершаем…",
    "warnings": {
      "network": "Отправляйте USDT только в сети TRC-20 (Tron). Переводы в других сетях не зачисляются.",
      "minAmount": "Переводы меньше {{min}} не зачисляются автоматически — если вы отправили меньше, обратитесь в поддержку.",
      "permanent": "Этот адрес закреплён за вами навсегда: отправляйте любую сумму в любое время. Каждый перевод зачисляется отдельно после подтверждения в блокчейне."
    },
    "retry": "Повторить",
    "payFailed": "Депозит зачислен, но завершить оплату не удалось.",
    "stillShort": "Депозит зачислен, но баланса всё ещё недостаточно для оплаты. Отправьте оставшуюся сумму на тот же адрес.",
    "loadFailed": "Не удалось загрузить адрес для депозита.",
    "copyAddress": "Скопировать адрес",
    "viewTx": "Открыть транзакцию в Tronscan"
  },
  "telegramLink": {
    "title": "Telegram",
    "intro": "Получайте уведомления в Telegram, когда посылка пришла на склад, когда ваша консолидация упакована и когда она отправлена.",
    "statusNotLinked": "Не привязано",
    "statusLinked": "Привязано",
    "statusPending": "Ожидаем подтверждения",
    "statusExpired": "Ссылка истекла",
    "linkedOn": "Привязано {{ date }}",
    "addedBy": "Бота добавил(а) {{ name }}",
    "open": "Открыть Telegram",
    "expiresIn": "Ссылка действует ещё {{ time }}",
    "expired": "Срок действия ссылки истёк. Получите новую, чтобы продолжить.",
    "newLink": "Получить новую ссылку",
    "loadFailed": "Не удалось загрузить статус привязки Telegram.",
    "retry": "Повторить",
    "private": {
      "title": "Личный чат",
      "hint": "Обновления приходят в ваш чат с ботом.",
      "link": "Привязать чат",
      "unlink": "Отвязать чат",
      "pendingHint": "Откройте ссылку там, где вы пользуетесь Telegram, или отсканируйте код телефоном, затем нажмите Start в чате с {{ bot }}."
    },
    "group": {
      "title": "Группа",
      "hint": "Добавьте бота в группу, например в чат вашей команды, и обновления будут приходить и туда.",
      "link": "Привязать группу",
      "unlink": "Отвязать группу",
      "pendingHint": "Откройте ссылку там, где вы пользуетесь Telegram, или отсканируйте код телефоном, затем выберите группу. Telegram добавит в неё {{ bot }} и привяжет её.",
      "unlinkHint": "После отвязки бот перестанет писать в группу, но останется в ней, пока вы его не удалите."
    }
  },
  "sms": {
    "tab": "SMS",
    "title": "SMS-номер",
    "subtitle": "Американский номер телефона для приёма SMS: регистрации, коды подтверждения. Только приём: без отправки, звонков и MMS.",
    "pricePerMonth": "{{price}} / месяц",
    "howItWorks": "Списывается с баланса раз в месяц. Отменить можно в любой момент: номер остаётся вашим до конца оплаченного месяца.",
    "preferredState": "Предпочтительный штат",
    "anyState": "Любой",
    "areaCode": "Код зоны (необязательно)",
    "buy": "Получить номер за {{price}}/месяц",
    "balance": "Баланс: {{balance}}",
    "balanceHint": "Для покупки номера на балансе нужно {{price}}.",
    "unavailable": "SMS-номера временно недоступны. Попробуйте позже.",
    "previousEnded": "Ваша предыдущая подписка завершена.",
    "endedOn": "Завершена {{date}}.",
    "endReason": {
      "user_canceled": "Предыдущая подписка завершилась: продление было отменено.",
      "insufficient_balance": "Предыдущая подписка завершилась: на балансе не хватило средств на продление.",
      "provisioning_failed": "Последний заказ не удалось выполнить; оплата возвращена на баланс.",
      "admin": "Предыдущая подписка была завершена службой поддержки."
    },
    "status": {
      "provisioning": "Подключаем",
      "active": "Активен",
      "canceled": "Продление отменено"
    },
    "provisioningHint": "Обычно занимает несколько секунд, иногда до 20 минут. Страница обновляется сама; если заказ не удастся, оплата вернётся на баланс.",
    "renewsOn": "Продлится {{date}} за {{price}}.",
    "endsOn": "Номер остаётся вашим до {{date}}.",
    "renewalWillFail": "Баланс отрицательный: продление {{date}} не пройдёт, и номер будет отключён.",
    "cancelRenewal": "Отменить продление",
    "resumeRenewal": "Возобновить продление",
    "resumeUnavailable": "Пока SMS-номера недоступны, возобновить продление нельзя.",
    "copyNumber": "Скопировать номер",
    "loadFailed": "Не удалось загрузить SMS-номер.",
    "retry": "Повторить",
    "failure": {
      "shortfall": "Недостаточно средств: пополните баланс на {{amount}}.",
      "invalid_region": "Выберите штат США из списка и укажите трёхзначный код зоны.",
      "no_numbers_available": "Для этого региона сейчас нет свободных номеров. Попробуйте другой штат или код зоны.",
      "order_failed": "Номер не удалось заказать. Оплата возвращена на баланс."
    },
    "messages": {
      "title": "Сообщения",
      "subtitle": "Входящие SMS на ваш номер, новые сверху.",
      "total": "Всего: {{count}}",
      "refresh": "Обновить",
      "empty": "Сообщений пока нет. SMS на ваш номер появятся здесь в течение минуты.",
      "loadFailed": "Не удалось загрузить сообщения.",
      "to": "на {{number}}",
      "copyCode": "Скопировать код"
    }
  },
  "shopify": {
    "items": "Товары",
    "profiles": "Профили",
    "createProfile": "Создать профиль",
    "editProfile": "Редактировать профиль",
    "viewProfile": "Детали профиля",
    "storeName": "Название магазина",
    "apiSecretKey": "API Secret Key",
    "adminApiAccessToken": "Admin API Access Token",
    "locationId": "ID локации",
    "deleteProfile": "Удалить профиль",
    "deleteConfirmation": "Вы уверены, что хотите удалить этот профиль?",
    "itemId": "ID товара",
    "state": "Статус",
    "addItem": "Добавить товар",
    "noProfiles": "Shopify профили не найдены",
    "noItems": "Товары не найдены",
    "exportToShopify": "Экспорт в Shopify",
    "exportDescription": "Экспортировать этот товар в ваш магазин Shopify. Товар будет синхронизирован с выбранным профилем Shopify.",
    "selectProfile": "Выберите профиль Shopify",
    "requestExport": "Запросить экспорт в Shopify",
    "exportSuccess": "Товар успешно добавлен в очередь экспорта Shopify",
    "noProfilesAvailable": "Нет доступных профилей Shopify. Пожалуйста, сначала создайте профиль.",
    "alreadyExported": "Этот товар уже экспортирован в Shopify.",
    "states": {
      "exporting": "В ожидании",
      "exported": "Экспортировано"
    }
  },
  "support": {
    "useSidebar": "Нажмите на иконку чата в боковом меню, чтобы связаться с нашей службой поддержки.",
    "unavailableImpersonation": "Чат поддержки недоступен в режиме имперсонации."
  },
  "expectedParcel": {
    "expectedParcelTitle": "Ожидаемая посылка",
    "trackingNumber": "Трекинг номер (необязательно)",
    "noTrackingNumber": "Трекинг номер не указан",
    "orderNumber": "Номер заказа",
    "storeName": "Название магазина",
    "customerComment": "Комментарий"
  }
}
